import { render, staticRenderFns } from "./TablePaginationV2.vue?vue&type=template&id=13e60eca&scoped=true&"
import script from "./TablePaginationV2.vue?vue&type=script&lang=js&"
export * from "./TablePaginationV2.vue?vue&type=script&lang=js&"
import style0 from "./TablePaginationV2.vue?vue&type=style&index=0&id=13e60eca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e60eca",
  null
  
)

export default component.exports